<template>
	<div class="">
		<Header></Header>
		<div class="Usercenter">
		  <div class="userlogo">
			  <div style="height: 20px;"></div>
			  <div>
				  <p><img src="https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2492559103,1792242662&fm=11&gp=0.jpg" alt=""></p>
				  <p>蛋蛋</p>
				  <p>退出登录</p>
			  </div>
		  </div>
		  <div class="courList w95">
			  <van-tabs title-inactive-color='#666' title-active-color='#007CCF' background="#fafafa"
			   swipeable animated  :ellipsis=false>
			  	<van-tab title="线下课" name='0'>
					<div class="hotmain">
						<div class="hotmainbox" v-for="(item,index) in 4" :key='index'>
							<div class="horimg">
								<img height="91px" src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1578748028343&di=2b49a4ffaeea38cab2490fd644f7faa4&imgtype=0&src=http%3A%2F%2Fn.sinaimg.cn%2Fsinacn20117%2F0%2Fw1024h576%2F20190905%2F34e4-ieftthx3876424.jpg"
								 alt="">
							</div>
							<div class="hottit">
								<p>2019年（下）国考教师资格证-考前…</p>
							</div>
							<div class="hotinfo">
								<span>查看详情</span><span><img src="../assets/home/lannest.png" alt=""></span>
							</div>
						</div>
					</div>	
				</van-tab>
			  	<van-tab title="线上课" name='1'>
					<div class="hotmain">
						<div class="hotmainbox" v-for="(item,index) in 4" :key='index'>
							<div class="horimg">
								<img height="91px" src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1578748028343&di=2b49a4ffaeea38cab2490fd644f7faa4&imgtype=0&src=http%3A%2F%2Fn.sinaimg.cn%2Fsinacn20117%2F0%2Fw1024h576%2F20190905%2F34e4-ieftthx3876424.jpg"
								 alt="">
							</div>
							<div class="hottit">
								<p>sdsd收到的范德萨范德萨佛挡杀佛第三方…</p>
							</div>
							<div class="hotinfo">
								<span>查看详情</span><span><img src="../assets/home/lannest.png" alt=""></span>
							</div>
						</div>
					</div>	
				</van-tab>
			  	<van-tab title="昵称设置" name='2'>
					<div class="setname">
						<input type="text" placeholder="请输入昵称">
					</div>
					<div class="setover">
						<p @click="setover()">确定</p>
					</div>
				</van-tab>
			  
			  	<van-tab title="修改密码" name='3'>
					<div class="dowapp">
						<img src="../assets/about/app.png" alt="">
					</div>
					<div class="dowtxt">
						<p>请到APP个人中心，进行密码修改~</p>
						<p>去下载APP</p>
					</div>
				</van-tab>
			  </van-tabs>
		  </div>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Vue from 'vue'
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import { Dialog } from 'vant';
	// 全局注册
	Vue.use(Dialog);
	export default {
		name: 'Usercenter',
		components: {
			Header,
			Fotter
		},
		data() {
			return {

			}

		},
		methods: {

			//打开详情
			openTeacher() {
				this.$router.push({
					path: '/TeacherDetail',
					name: '',
					params: {
						key: 'key',
					}

				})
			},
			setover(){
				Dialog.confirm({
				  title: '恭喜',
				  showCancelButton:false,
				  message: '手机号码修改成功！'
				}).then(() => {
				  // on confirm
				}).catch(() => {
				  // on cancel
				});
			}
		}
	}
</script>

<style scoped>
	.userlogo{
		height: 196px;
		background:linear-gradient(180deg,rgba(0,124,207,1) 0%,rgba(128,204,255,1) 100%);
	}
	.userlogo p{
		text-align: center;
	}
	.userlogo p:nth-child(1){
		    width: 60px;
			height: 60px;
			border: 1px solid #c1c4ca;
			border-radius: 100%;
			line-height: 30px;
			margin: 0px auto;
			text-align: center;
	}
	.userlogo p:nth-child(1) img{
		width: 100%;
		height: 100%;
		border-radius: 100%;
	}
	.userlogo p:nth-child(2){
		color: #fff;
		margin-top: 10px;
		font-weight: bold;
	}
	.userlogo p:nth-child(3){
		border: 1px solid #fff;
		width: 196px;
		height: 37px;
		margin: 16px auto;
		border-radius: 20px;
		line-height: 37px;
		color: #fff;
	}
	.courList{
		margin:  20px auto;
	}
	.setname{
		width: 100%;
		height: 40px;
		border-bottom: 1px solid #ccc;
		position: relative;
	}
	.setname input{
		width: 100%;
		height: 30px;
		border: 0px;
		position: absolute;
		bottom: 0px;
		background: #fafafa;
		font-size: 14px;
		text-indent: 10px;
	}
	.dowapp{
		width: 226px;
		height: 138px;
		margin: 20px auto;
	}
	.dowapp img{
		width: 100%;
		height: 100%;
	}
	.dowtxt p:nth-child(1){
		font-size:12px;
		text-align: center;
		font-weight:600;
		line-height:25px;
		color:rgba(0,124,207,1);
	}
	.dowtxt p:nth-child(2){
		width:90%;
		height:50px;
		background:rgba(0,124,207,1);
		margin:20px auto;
		border-radius: 20px;
		text-align: center;
		line-height: 50px;
		color: #fff;
		font-size: 16px;
	}
	.setover p{
		width:90%;
		height:50px;
		background:rgba(0,124,207,1);
		margin:20px auto;
		border-radius: 20px;
		text-align: center;
		line-height: 50px;
		color: #fff;
		font-size: 16px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Usercenter.vue